import React from "react";
import { Modal, Button } from "semantic-ui-react";
import "./CustomModal.css"; // Custom CSS file for modal styling

/**
 * Reusable confirmation modal for yes/no actions (e.g. opt-out re-enable, delete).
 * Uses className (not class) per React/JSX convention.
 */
const ConfirmationModal = ({ open, onClose, onConfirm, title = 'Confirm your action', content = 'Are you sure you want to delete?', cancelLabel = 'No', confirmLabel = 'Yes' }) => {
  return (
      <Modal open={open} onClose={onClose} size="small" className="custom-modal">
          <Modal.Content>
            <button type="button" className="close linear-gradient" onClick={onClose} data-dismiss="modal" aria-label="Close">X</button>
            <div className="modal-header"><h5 className="modal-title">{title}</h5></div>
            <p className="custom-modal-content">{content}</p>
          </Modal.Content>
          <div className="modal-footer">
              <button type="button" className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small" onClick={onClose} data-dismiss="modal" ><span>{cancelLabel}</span></button>
              <button type="button" onClick={onConfirm} className="btn linear-gradient yr-submitbtn btn-sm" >{confirmLabel}</button>
          </div>
      </Modal>
  );
};

export default ConfirmationModal;
